import React from "react";
import { useTranslation } from "react-i18next";

const defaultSelectorKeys = [
  { key: "1month", value: 1 },
  { key: "3month", value: 3 },
  { key: "6month", value: 6 },
  { key: "1year", value: 12 },
  { key: "lifetime", value: "lifetime" },
];

const Selector = ({ text = "", value, selectedValue, onClick }) => (
  <button
    data-button-type={selectedValue === value ? "primary" : "secondary"}
    onClick={(e) => onClick(e, value)}
  >
    {text}
  </button>
);

const RangeSelectors = ({
  selectors: selectorsProp,
  onClick = () => {},
  selectedValue,
}) => {
  const { t } = useTranslation("coaching-portal");
  const selectors =
    selectorsProp ||
    defaultSelectorKeys.map(({ key, value }) => ({
      text: t(`rangeSelectors.${key}`),
      value,
    }));
  return (
    <div className="range-selectors">
      {selectors.map((props, idx) => (
        <Selector
          {...props}
          key={props.value ?? idx}
          onClick={onClick}
          selectedValue={selectedValue}
        />
      ))}
    </div>
  );
};

export default RangeSelectors;
